export type FlagDefinition = {
  readonly owner: string;
  readonly createdOn: string;
  readonly expiresOn: string;
  readonly defaultValue: boolean;
  readonly removal: string;
};

export const FLAGS = {
  'admin.dashboard-personalize': {
    owner: 'admin-portal',
    createdOn: '2026-10-29',
    expiresOn: '2026-12-28',
    defaultValue: false,
    removal: 'docs/design/2026-10-29-dashboard-fixed-and-filters.md',
  },
} as const satisfies Readonly<Record<string, FlagDefinition>>;

export type FlagName = keyof typeof FLAGS;

export const FLAG_NAMES = Object.keys(FLAGS) as readonly FlagName[];
